/* eslint-disable complexity */

/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import { Gap, Button } from '@osui/ui';
import { Submit, FooterWrapper, useFooterChildren } from '../../Other';
import { useValidateState } from '../../Other/Submit/hooks';
import { useStepContext } from './stepContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StepFooter(props) {
  var _props$showCancel;

  const {
    submitText,
    handleNextStep,
    align = 'left',
    onCancel
  } = props;
  const {
    step,
    prevStep,
    nextStep,
    isLast
  } = useStepContext();
  const {
    state
  } = useValidateState();
  const {
    children,
    disabledNext
  } = useFooterChildren(props, {
    step
  });
  const showCancel = (_props$showCancel = props.showCancel) !== null && _props$showCancel !== void 0 ? _props$showCancel : true;
  return /*#__PURE__*/_jsx(FooterWrapper, {
    fixed: true,
    align: align,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [align === 'right' && children, step !== 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          size: "large",
          onClick: prevStep,
          minWidth: 88,
          children: "\u4E0A\u4E00\u6B65"
        }), /*#__PURE__*/_jsx(Gap, {
          factor: 4,
          orientation: "horizontal"
        })]
      }), !isLast && /*#__PURE__*/_jsx(Button, {
        loading: state.validating,
        onClick: handleNextStep !== null && handleNextStep !== void 0 ? handleNextStep : nextStep,
        disabled: disabledNext,
        type: "primary",
        size: "large",
        minWidth: 88,
        children: "\u4E0B\u4E00\u6B65"
      }), isLast && (props.customSubmit || /*#__PURE__*/_jsx(Submit, {
        size: "large",
        minWidth: 88,
        disabled: disabledNext,
        children: submitText !== null && submitText !== void 0 ? submitText : '提交'
      })), /*#__PURE__*/_jsx(Gap, {
        factor: 4,
        orientation: "horizontal"
      }), showCancel && /*#__PURE__*/_jsx(Button, {
        onClick: onCancel,
        minWidth: 88,
        size: "large",
        children: "\u53D6\u6D88"
      }), align === 'left' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Gap, {
          factor: 4,
          orientation: "horizontal"
        }), children]
      })]
    })
  });
}
StepFooter.displayName = "StepFooter";
//# sourceMappingURL=es/FormUI/Step/StepFooter.js.map